var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-widgetTemplate-page"},[_c('BackTitle',{attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" Create widget template ")]),_c('WidgetTemplateForm',{attrs:{"value":_vm.widgetTemplate,"submitButtonText":"Add","isSubmitting":_vm.isSubmitting},on:{"submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }